module.exports = __webpack_public_path__ + "static/media/LogoSmall.04b21e1d.png";